import type { ReactNode } from 'react';
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@/components/ui/drawer';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { useIsMobile } from '@/hooks';
import { cn } from '@/utils';

interface ProbabilityResponsiveModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	description?: string;
	children: ReactNode;
	drawerClassName?: string;
	dialogClassName?: string;
	shouldScaleBackground?: boolean;
	hideDrawerHandle?: boolean;
	dialogPlacement?: 'center' | 'top-right';
}

const DEFAULT_DRAWER_CLASS = "rounded-t-2xl border-[#DCE3F9] bg-white px-0 pb-4 font-['DM_Sans']";
const DEFAULT_DIALOG_CLASS = "border-[#DCE3F9] bg-white p-0 font-['DM_Sans']";
const DEFAULT_DIALOG_OVERLAY = 'backdrop-blur-sm bg-[rgba(20,24,33,0.32)]';

export function ProbabilityResponsiveModal({
	open,
	onOpenChange,
	title,
	description,
	children,
	drawerClassName,
	dialogClassName,
	shouldScaleBackground = false,
	hideDrawerHandle = true,
	dialogPlacement = 'center',
}: ProbabilityResponsiveModalProps) {
	const isMobile = useIsMobile();

	if (isMobile) {
		return (
			<Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={shouldScaleBackground}>
				<DrawerContent
					hideHandle={hideDrawerHandle}
					className={cn(DEFAULT_DRAWER_CLASS, drawerClassName)}
				>
					<DrawerTitle className="sr-only">{title}</DrawerTitle>
					{description ? (
						<DrawerDescription className="sr-only">{description}</DrawerDescription>
					) : null}
					{children}
				</DrawerContent>
			</Drawer>
		);
	}

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				hideCancelIcon
				placement={dialogPlacement}
				className={cn(DEFAULT_DIALOG_CLASS, dialogClassName)}
				overlayClassName={DEFAULT_DIALOG_OVERLAY}
			>
				<DialogTitle className="sr-only">{title}</DialogTitle>
				{description ? (
					<DialogDescription className="sr-only">{description}</DialogDescription>
				) : null}
				{children}
			</DialogContent>
		</Dialog>
	);
}
